// extracted by mini-css-extract-plugin
export var header = "Header-module--header--qgajU";
export var gradient = "Header-module--gradient--08P2m";
export var alignFull = "Header-module--alignFull--LDEfY";
export var headerContainer = "Header-module--headerContainer--IT0aA";
export var image = "Header-module--image--shi1O";